import { cva } from 'class-variance-authority';

export const container = cva([
  'flex flex-col items-center justify-center gap-8',
  'max-w-3xl mx-auto h-full p-8',
]);

export const title = cva(['text-3xl font-bold text-center text-neutral-900']);
